export class PacoteObservacao {
    public idPacote: string;
    public loteTrabalho: string;
    public observacao: string = '';
    public motivoCanMkt: string = '';
    public codigoRastreioReverso: string = '';
    public infoLote: string = '';
}